import { render, staticRenderFns } from "./MediaSectionsLandingPage.vue?vue&type=template&id=601b5e97&scoped=true"
import script from "./MediaSectionsLandingPage.vue?vue&type=script&lang=js"
export * from "./MediaSectionsLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b5e97",
  null
  
)

export default component.exports